<template>
  <div>
    <h5 class="mb-2">
      {{ dataComponent.name }}
    </h5>

    <b-row class="mt-3">
      <b-col cols="9">
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Date</label>
            </b-col>
            <b-col cols="9">
              <b-row>
                <b-col cols="6">
                  <label>From</label>
                  <j-datepicker
                    :disabled="true"
                    format="MMM dd, yyyy"
                    placeholder="Ex. Jan 01, 2019"
                  />
                </b-col>
                <b-col cols="6">
                  <label>To</label>
                  <j-datepicker
                    :disabled="true"
                    format="MMM dd, yyyy"
                    placeholder="Ex. Jan 01, 2019"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Organization Unit</label>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label mr-2"
                >
                  Select All
                </label>
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-multi-select
                :disabled="true"
                value-format="object"
                placeholder="Select Org Unit"
              />
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Shift</label>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label mr-2"
                >
                  Select All
                </label>
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-multi-select
                :disabled="true"
                value-format="object"
                placeholder="Select Shift"
              />
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group>
          <b-row>
            <b-col cols="3">
              <br>
              <label>Name</label>
            </b-col>
            <b-col cols="9">
              <div class="d-flex justify-content-end">
                <label
                  style="color: #4a90e2"
                  class="select-label mr-2"
                >
                  Select All
                </label>
                <label
                  style="color: #4a90e2"
                  class="select-label"
                >
                  Unselect All
                </label>
              </div>
              <j-multi-select
                :disabled="true"
                value-format="object"
                placeholder="Select Employee"
              />
              <b-button
                class="btn blue"
              >
                <i class="fa fa-search mr-2" />Search
              </b-button>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="8">
        <div class="table-switcher">
          <b-row>
            <b-col cols="6">
              <div class="switch-active">Summary</div>
            </b-col>
            <b-col cols="6">
              <div>Detail Summary</div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <hr>

    <b-button
      class="btn grey btn-import-form"
      disabled
    >
      <i class="fa fa-cloud-download fa-lg"/> Generate xls
    </b-button>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      columns: [
        'EMPLOYEE ID',
        'EMPLOYEE CODE',
        'NAME',
        'EMAIL',
        'POSITION',
        'ORGANIZATION UNIT',
        'TOTAL VISIT',
        'TOTAL WORKING DAYS',
        'TOTAL ATTENDANCE FRAUD',
        'TOTAL ABSENCE',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .table-switcher {
    height: 40px;
    margin: 48px 118px 0 0;
    padding: 4px 39px 4px 5px;
    border-radius: 8px;
    box-shadow: inset 0 0 8px 0 rgba(183, 183, 183, 0.39);
    background-color: #f1f1f1;
    text-align: center;

    div {
      margin-top: 1px;
      cursor: pointer;
    }
  }

  .switch-active {
    padding: 2px;
    border-radius: 4px;
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyAttendanceReport.vue